<template>
    <v-sheet
        v-if="storeAuth.isAuth"
        density="compact"
        absolute
        flat
        :color="isLive ? 'white' : 'staging'"
        class="border-sm border-opacity-100 flex-wrap position-relative"
        :class="isLive ? 'border-custom_color_28' : 'border-white'"
        border="surface"
        :style="`padding-right: ${isMobile ? '0' : '15'}px; border-radius: 4px; min-height: ${
            isLive ? '52' : '53.5'
        }px;`"
    >
        <div
            class="d-flex flex-grow-1 flex-wrap"
            :class="isMobile ? 'flex-column align-start justify-start' : 'align-center justify-space-between'"
        >
            <v-btn
                :href="getCoPageURL('/home')"
                variant="text"
                class="pa-0"
                height="40"
                style="margin-left: 15px; margin-bottom: 2px; margin-top: 1px"
                base-color="transparent"
                :class="{
                    'mt-1': isMobile,
                    'border-t-sm': isMobile,
                    'border-white': isLive,
                }"
            >
                <img src="@/assets/logo-small.png" alt="" style="height: 40px" class="mr-2" />
                <v-hover v-slot="{ isHovering, props }">
                    <div
                        v-bind="props"
                        style="font-size: 18px; margin-left: -0.3px; font-weight: 500"
                        class="text-capitalize"
                        :class="[
                            isLive
                                ? isHovering
                                    ? 'text-primary'
                                    : 'text-custom_color_18'
                                : isHovering
                                ? 'text-primary'
                                : 'text-white',
                        ]"
                    >
                        Channel Optimiser
                    </div>
                </v-hover>
            </v-btn>
            <v-spacer />
            <v-btn
                v-if="isMobile"
                @click="isOpen = !isOpen"
                min-width="44"
                width="44"
                max-width="44"
                height="34"
                min-height="34"
                color="custom_color_45"
                :variant="isFocus ? 'flat' : 'outlined'"
                :ripple="false"
                @focus="isFocus = true"
                @blur="isFocus = false"
                style="right: -1px"
                class="position-absolute top-0 mt-2 mr-4"
            >
                <v-icon color="custom_color_44" size="30" icon="mdi-menu" />
            </v-btn>
            <div
                :style="
                    isOpen || !isMobile
                        ? 'max-height: 1000px;transition: all 0.6s'
                        : 'max-height: 0;transition: all 0.6s'
                "
                class="overflow-hidden d-flex"
                :class="{ 'w-100': isMobile }"
            >
                <div
                    class="d-flex flex-wrap"
                    :style="isMobile && 'min-height: 560px; margin-bottom: -22px'"
                    :class="isMobile ? 'flex-column border-t-sm w-100 mt-1 pt-1' : 'ml-auto align-center'"
                >
                    <v-expansion-panels
                        v-if="isMobile"
                        variant="accordion"
                        rounded="0"
                        collapse-icon=""
                        expand-icon=""
                        bg-color="transparent"
                        flat
                        class="hide-expansion-icon mt-1"
                        :ripple="false"
                    >
                        <v-expansion-panel
                            v-for="navigation in navigations"
                            :key="navigation.title"
                            color="transparent"
                            height="40"
                            min-height="40"
                            max-height="40"
                        >
                            <v-expansion-panel-title class="pa-0">
                                <template v-slot:default="{ expanded }">
                                    <div
                                        class="d-flex flex-grow-1 h-100 align-center text-body-1"
                                        :class="{ 'text-primary': expanded, 'bg-white': expanded }"
                                        style="padding-left: 15px"
                                    >
                                        <v-sheet color="transparent" class="d-flex align-center">
                                            <span
                                                :class="
                                                    isLive
                                                        ? expanded
                                                            ? 'text-primary'
                                                            : 'text-custom_color_18'
                                                        : 'opacity-100'
                                                "
                                                class="font-weight-light"
                                                style="letter-spacing: 0"
                                            >
                                                {{ navigation.title }}
                                            </span>
                                        </v-sheet>
                                        <v-icon
                                            size="12"
                                            class="ml-1"
                                            icon="custom:icon-caret-down"
                                            :color="isLive ? (expanded ? 'text-primary' : 'custom_color_18') : ''"
                                            style="margin-top: 1px"
                                        ></v-icon>
                                    </div>
                                </template>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text class="pa-0">
                                <template v-slot:default>
                                    <v-list
                                        density="comfortable"
                                        class="text-capitalize pb-2 rounded-t-0"
                                        :border="
                                            isLive || isMobile ? `primary opacity-100 t-sm` : `silver opacity-100 t-sm`
                                        "
                                    >
                                        <v-list-item
                                            v-for="child in navigation.children"
                                            :key="child.title"
                                            :href="child.path && getCoPageURL(child.path)"
                                            :to="child.name && { name: child.name, query: child.query }"
                                            class="mt-n2 mb-n2"
                                            min-height="38"
                                        >
                                            <span
                                                class="font-weight-light text-custom_color_18"
                                                style="margin-left: 6px"
                                            >
                                                {{ child.title }}
                                            </span>
                                        </v-list-item>
                                    </v-list>
                                </template>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <v-menu
                        v-else
                        v-for="navigation in navigations"
                        :key="navigation.title"
                        open-on-hover
                        :open-on-click="false"
                        :open-on-focus="false"
                        open-delay="50"
                        close-delay="25"
                        location="bottom right"
                        transition="false"
                    >
                        <template v-slot:activator="{ props }">
                            <v-btn
                                class="text-capitalize text-subtitle-1 opacity-100"
                                :class="{
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile,
                                }"
                                variant="plain"
                                :ripple="false"
                                :rounded="0"
                                v-bind="props"
                                :height="isMobile ? 41 : isLive ? 52 : 54"
                                style="margin-top: -1px; padding-left: 13.25px; padding-right: 13.25px"
                            >
                                <v-hover v-slot="{ isHovering, props }">
                                    <v-sheet v-bind="props" height="50" color="transparent" class="d-flex align-center">
                                        <span
                                            :class="
                                                isLive
                                                    ? isHovering
                                                        ? 'text-primary'
                                                        : 'text-custom_color_18'
                                                    : 'opacity-100'
                                            "
                                            class="font-weight-light"
                                            style="letter-spacing: 0"
                                        >
                                            {{ navigation.title }}
                                        </span>
                                    </v-sheet>
                                    <v-icon
                                        v-bind="props"
                                        size="12"
                                        class="ml-1"
                                        icon="custom:icon-caret-down"
                                        :color="isLive ? (isHovering ? 'text-primary' : 'custom_color_18') : ''"
                                        style="margin-top: 1px"
                                    ></v-icon>
                                </v-hover>
                            </v-btn>
                        </template>
                        <v-list
                            density="comfortable"
                            v-if="navigation.children.length"
                            class="text-capitalize pb-2 rounded-t-0"
                            rounded="8"
                            :border="isLive || isMobile ? `silver opacity-100 t-sm` : `silver opacity-100 t-sm`"
                            :style="isMobile ? 'margin-left: -12px' : 'margin-top: -1px;'"
                        >
                            <v-list-item
                                v-for="child in navigation.children"
                                :key="child.title"
                                :href="child.path && getCoPageURL(child.path)"
                                :to="child.name && { name: child.name, query: child.query }"
                                base-color="white"
                                active-class="text-text-custom_color_18 opacity-100"
                                class="mt-n2 mb-n2"
                                min-height="38"
                            >
                                <span class="font-weight-light text-custom_color_18">{{ child.title }}</span>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <div
                        v-if="storeAuth.isUserHasRole(['GlobalSearch']) && isMobile"
                        style="padding-top: 10px; margin-left: 5px; margin-right: 5px"
                        class="d-flex align-center border-t-sm border-b-sm pl-4 mt-2 mb-2 pb-3"
                    >
                        <v-btn
                            @click="toggleSearch"
                            density="compact"
                            :variant="isLive ? 'outlined' : 'flat'"
                            rounded="circle"
                            min-width="33"
                            width="33"
                            :color="isLive ? 'silver' : ''"
                            height="31"
                            class="pa-0"
                            :style="isLive ? `margin-top: 1px` : `margin-top: 2px`"
                        >
                            <v-icon color="black" icon="custom:icon-search-font" />
                        </v-btn>
                        <v-text-field
                            v-show="isSearchActive"
                            v-model="searchString"
                            class="ml-2 mr-2"
                            density="default"
                            variant="outlined"
                            bg-color="white"
                            color="primary"
                            ref="search"
                            hide-details
                            single-line
                            @blur="toggleSearch"
                            @keyup.enter="searchAction"
                            aria-controls="false"
                            rounded
                            flat
                            autocomplete="off"
                        />
                    </div>
                    <v-menu open-on-hover open-delay="0" location="bottom right">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                class="text-capitalize text-subtitle-1 opacity-100"
                                @click="storeAuth.logout()"
                                :class="{
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile,
                                }"
                                :style="
                                    isLive
                                        ? `margin-left: -3px; margin-bottom: 2px`
                                        : `margin-left: -3px; margin-bottom: 1px`
                                "
                                variant="plain"
                                :rounded="0"
                                v-bind="props"
                                :height="isMobile ? 39 : isLive ? '100%' : '52'"
                                :color="isLive ? 'custom_color_18' : ''"
                            >
                                <v-hover v-slot="{ isHovering, props }">
                                    <span :class="isHovering ? 'text-primary' : ''" v-bind="props">Logout</span>
                                </v-hover>
                            </v-btn>
                        </template>
                    </v-menu>
                    <v-menu
                        v-if="storeAuth.isUserHasRole(['Web_Nav_Support'])"
                        open-on-hover
                        open-delay="0"
                        location="bottom right"
                    >
                        <template v-slot:activator="{ props }">
                            <v-btn
                                class="text-capitalize text-subtitle-1 opacity-100"
                                min-width="38"
                                :to="{ name: 'support' }"
                                :class="{
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile,
                                }"
                                :style="
                                    isLive
                                        ? `margin-right: -2px; margin-left: -4px; margin-bottom: 2px`
                                        : `margin-right: -2px; margin-left: -4px; margin-bottom: 1px`
                                "
                                variant="plain"
                                :rounded="0"
                                v-bind="props"
                                :height="isMobile ? 39 : isLive ? '100%' : '52'"
                                :color="isLive ? 'custom_color_18' : ''"
                            >
                                <v-hover v-slot="{ isHovering, props }">
                                    <template v-if="isMobile">Help</template>
                                    <span :class="isHovering ? 'text-primary' : ''" v-bind="props">?</span>
                                </v-hover>
                            </v-btn>
                        </template>
                    </v-menu>
                    <v-menu
                        v-if="storeAuth.isUserHasRole(['Web_Nav_Admin_importexportmgt'])"
                        open-on-hover
                        open-delay="0"
                        location="bottom right"
                    >
                        <template v-slot:activator="{ props }">
                            <v-btn
                                class="text-capitalize text-subtitle-1 opacity-100"
                                min-width="46"
                                :to="{ name: 'import.data.sheets' }"
                                :href="getCoPageURL('/ImportCenter')"
                                :class="{
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile,
                                }"
                                :style="
                                    isLive
                                        ? `padding-bottom: 2px; margin-right: -2px; margin-bottom: 2px`
                                        : `padding-bottom: 2px; margin-right: -2px; margin-bottom: 1px`
                                "
                                variant="plain"
                                :rounded="0"
                                v-bind="props"
                                :height="isMobile ? 39 : isLive ? '100%' : '52'"
                            >
                                <v-hover v-slot="{ isHovering, props }">
                                    <v-icon
                                        v-bind="props"
                                        :color="isLive ? (isHovering ? 'text-primary' : 'custom_color_18') : ''"
                                        size="16"
                                        icon="custom:icon-arrow-circle-up"
                                    />
                                </v-hover>
                            </v-btn>
                        </template>
                    </v-menu>
                    <v-menu
                        v-if="storeAuth.isUserHasRole(['COBI_Access'])"
                        open-on-hover
                        open-delay="0"
                        location="bottom right"
                    >
                        <template v-slot:activator="{ props }">
                            <v-btn
                                class="text-capitalize text-subtitle-1 opacity-100"
                                min-width="50"
                                :href="getCoPageURL('/Pulse')"
                                :class="{
                                    'text-primary': props['aria-expanded'] === 'true',
                                    'bg-white': props['aria-expanded'] === 'true',
                                    'justify-start': isMobile,
                                    'mb-4': isMobile,
                                    'mr-n4': !(storeAuth.isUserHasRole(['GlobalSearch']) && !isMobile),
                                }"
                                :style="
                                    isLive
                                        ? `padding-bottom: 2px; margin-right: 14px; margin-bottom: 2px`
                                        : `padding-bottom: 2px; margin-right: 14px; margin-bottom: 1px`
                                "
                                variant="plain"
                                :rounded="0"
                                v-bind="props"
                                :height="isMobile ? 39 : isLive ? '100%' : '52'"
                            >
                                <v-hover v-slot="{ isHovering, props }">
                                    <v-icon
                                        v-bind="props"
                                        :color="isLive ? (isHovering ? 'text-primary' : 'custom_color_18') : ''"
                                        size="20"
                                        icon="custom:icon-wave-square"
                                    />
                                    <span v-if="isMobile" class="ml-1" :class="{ 'text-custom_color_18': isLive }">
                                        Alerts
                                    </span>
                                </v-hover>
                            </v-btn>
                        </template>
                    </v-menu>
                    <v-btn v-if="false" @click="toggleTheme" :icon="'mdi-theme-light-dark'" variant="text"></v-btn>
                    <div v-if="storeAuth.isUserHasRole(['GlobalSearch']) && !isMobile" class="d-flex align-center">
                        <v-btn
                            @click="toggleSearch"
                            density="compact"
                            :variant="isLive ? 'outlined' : 'flat'"
                            rounded="circle"
                            min-width="33"
                            width="33"
                            :color="isLive ? 'silver' : ''"
                            height="31"
                            class="pa-0"
                            :style="isLive ? `margin-top: 1px` : `margin-top: 2px`"
                        >
                            <v-icon color="black" icon="custom:icon-search-font" />
                        </v-btn>
                        <v-text-field
                            v-show="isSearchActive"
                            v-model="searchString"
                            class="ml-2"
                            max-width="180"
                            width="180"
                            density="default"
                            variant="outlined"
                            bg-color="white"
                            color="primary"
                            ref="search"
                            hide-details
                            single-line
                            @blur="toggleSearch"
                            @keyup.enter="searchAction"
                            aria-controls="false"
                            rounded
                            flat
                            autocomplete="off"
                        />
                    </div>
                </div>
            </div>
        </div>
    </v-sheet>
</template>
<script setup lang="ts">
import { useAuthStore } from '@/stores/useAuthStore'
import { useDisplay, useTheme } from 'vuetify'
import { computed, nextTick, ref, useTemplateRef } from 'vue'
import useNavigations from '@/components/navigations/composables/useNavigations'

const theme = useTheme()

const storeAuth = useAuthStore()

const isSearchActive = ref(false)
const searchString = ref('')
const search = useTemplateRef<HTMLInputElement>('search')
const isFocus = ref(false)
const isOpen = ref(false)

const { navigations } = useNavigations()
const { width } = useDisplay()

function toggleSearch() {
    isSearchActive.value = !isSearchActive.value
    if (isSearchActive.value) {
        nextTick(() => {
            if (search.value) search.value.focus()
        })
    } else {
        searchString.value = ''
    }
}

const isLive = process.env.VUE_APP_ENV === 'master'

const isMobile = computed(() => width.value < 768)

function searchAction() {
    if (searchString.value.length) location.href = getCoPageURL(`/GlobalSearch?searchText=${searchString.value}`)
}

function getCoPageURL(path: string) {
    return `${process.env.VUE_APP_CO_BASE_URL}${path}`
}

function toggleTheme() {
    theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark'
}
</script>
